// extracted by mini-css-extract-plugin
export default {"menu":"Navigation_menu__PvD3w","link":"Navigation_link__7LgVK"};